'use client';

import { useSiteConfig } from '@/hooks/useSiteConfig';
import { MaintenanceBannerContent } from './MaintenanceBannerContent';

type MaintenanceBannerProps = {
  onDismiss?: () => void;
};

const MaintenanceBanner = ({ onDismiss }: MaintenanceBannerProps) => {
  const { maintenance } = useSiteConfig();

  return <MaintenanceBannerContent maintenance={maintenance ?? null} onDismiss={onDismiss} />;
};

export default MaintenanceBanner;
export { MaintenanceBannerContent } from './MaintenanceBannerContent';
